import { AraIcon } from './AraIcon';
import { Injectable } from '@angular/core';

@Injectable()
export class Icons {
	allIcons = [
		new AraIcon('add', 'mat:add'),
		new AraIcon('addComment', 'mat:add_comment'),
		new AraIcon('addLink', 'mat:add_link'),
		new AraIcon('archive', 'mat:archive'),
		new AraIcon('arrowBack', 'mat:arrow_back'),
		new AraIcon('bugReport', 'mat:bug_report'),
		new AraIcon('calendarToday', 'mat:calendar_today'),
		new AraIcon('calendarViewDay', 'mat:calendar_view_day'),
		new AraIcon('calendarViewMonth', 'mat:calendar_view_month'),
		new AraIcon('calendarViewWeek', 'mat:calendar_view_week'),
		new AraIcon('calendarViewWorkWeek', 'mat:view_week'),
		new AraIcon('cancel', 'mat:cancel'),
		new AraIcon('cancelCircle', 'mat:highlight_off'),
		new AraIcon('celebration', 'mat:celebration'),
		new AraIcon('checkCircle', 'mat:check_circle'),
		new AraIcon('chevronDown', 'mat:keyboard_arrow_down'),
		new AraIcon('chevronLeft', 'mat:chevron_left'),
		new AraIcon('chevronRight', 'mat:chevron_right'),
		new AraIcon('chevronUp', 'mat:keyboard_arrow_up'),
		new AraIcon('circle', 'mat:circle'),
		new AraIcon('close', 'mat:close'),
		new AraIcon('comment', 'mat:comment'),
		new AraIcon('contrast', 'mat:contrast'),
		new AraIcon('cooling', 'mat:ac_unit'),
		new AraIcon('copy', 'mat:content_copy'),
		new AraIcon('dashboard', 'mat:dashboard'),
		new AraIcon('delete', 'mat:delete'),
		new AraIcon('deleteLink', 'mat:link_off'),
		new AraIcon('development', 'mat:api'),
		new AraIcon('directions_car', 'mat:directions_car'),
		new AraIcon('downloading', 'mat:downloading'),
		new AraIcon('dragIndicator', 'mat:drag_indicator'),
		new AraIcon('edit', 'mat:edit'),
		new AraIcon('error', 'mat:error'),
		new AraIcon('family', 'mat:family_restroom'),
		new AraIcon('fileAttachment', 'mat:file_present'),
		new AraIcon('fileDownload', 'mat:download'),
		new AraIcon('filter', 'mat:filter_alt'),
		new AraIcon('filterOff', 'mat:filter_alt_off'),
		new AraIcon('filterList', 'mat:filter_list'),
		new AraIcon('group', 'mat:group'),
		new AraIcon('handyman', 'mat:handyman'),
		new AraIcon('heating', 'mat:fireplace'),
		new AraIcon('heatingWarmwater', 'mat:water_damage'),
		new AraIcon('help', 'mat:help'),
		new AraIcon('helpOutline', 'mat:help_outline'),
		new AraIcon('history', 'mat:history'),
		new AraIcon('holidayVillage', 'mat:holiday_village'),
		new AraIcon('hourglass_top', 'mat:hourglass_top'),
		new AraIcon('info', 'mat:info'),
		new AraIcon('infoSheet', 'mat:file_copy'),
		new AraIcon('libraryAdd', 'mat:library_add'),
		new AraIcon('link', 'mat:link'),
		new AraIcon('locationOn', 'mat:location_on'),
		new AraIcon('logout', 'mat:logout'),
		new AraIcon('manageAccounts', 'mat:manage_accounts'),
		new AraIcon('map', 'mat:map'),
		new AraIcon('menu', 'mat:menu'),
		new AraIcon('more_vert', 'mat:more_vert'),
		new AraIcon('outbox', 'mat:outbox'),
		new AraIcon('pdf', 'mat:picture_as_pdf'),
		new AraIcon('people', 'mat:groups_2'),
		new AraIcon('permissions', 'mat:tune'),
		new AraIcon('person', 'mat:person'),
		new AraIcon('personAdd', 'mat:person_add'),
		new AraIcon('print', 'mat:print'),
		new AraIcon('realEstate', 'mat:apartment'),
		new AraIcon('recalculate', 'mat:reset_tv'),
		new AraIcon('refresh', 'mat:refresh'),
		new AraIcon('replay', 'mat:replay'),
		new AraIcon('renew', 'mat:autorenew'),
		new AraIcon('router', 'mat:router'),
		new AraIcon('save', 'mat:save'),
		new AraIcon('search', 'mat:search'),
		new AraIcon('security', 'mat:security'),
		new AraIcon('segment', 'mat:segment'),
		new AraIcon('settings', 'mat:settings'),
		new AraIcon('smartphone', 'mat:smartphone'),
		new AraIcon('sort_by_alpha', 'mat:sort_by_alpha'),
		new AraIcon('star', 'mat:star'),
		new AraIcon('sync', 'mat:sync'),
		new AraIcon('syncAlt', 'mat:sync_alt'),
		new AraIcon('tenantunit', 'mat:door_back'),
		new AraIcon('tenantunitDetails', 'mat:group'),
		new AraIcon('thumbUp', 'mat:thumb_up'),
		new AraIcon('ticketManagement', 'mat:task'),
		new AraIcon('ticketManagementDetail', 'mat:plagiarism'),
		new AraIcon('uploadFile', 'mat:upload_file'),
		new AraIcon('upload', 'mat:upload'),
		new AraIcon('uvi', 'mat:speed'),
		new AraIcon('uviChart', 'mat:equalizer'),
		new AraIcon('warning', 'mat:warning'),
		new AraIcon('visibility', 'mat:visibility'),
		new AraIcon('visibility_off', 'mat:visibility_off'),
		new AraIcon('workOrders', 'mat:content_paste'),
		new AraIcon('workOrdersDetail', 'mat:content_paste_search'),
		new AraIcon('battery1', 'mat:battery_2_bar'),
		new AraIcon('battery2', 'mat:battery_3_bar'),
		new AraIcon('battery3', 'mat:battery_4_bar'),
		new AraIcon('battery4', 'mat:battery_5_bar'),
		new AraIcon('battery5', 'mat:battery_full'),
		new AraIcon('batteryCharge', 'mat:battery_charging_full'),
		new AraIcon('signal0', 'mat:signal_cellular_connected_no_internet_0_bar'),
		new AraIcon('signal1', 'mat:signal_cellular_alt_1_bar'),
		new AraIcon('signal2', 'mat:signal_cellular_alt_2_bar'),
		new AraIcon('signal3', 'mat:signal_cellular_alt'),
		new AraIcon('signal4', 'mat:signal_cellular_4_bar'),
		new AraIcon('flagAT', 'flag:austria'),
		new AraIcon('flagDE', 'flag:germany'),
		new AraIcon('flagUS', 'flag:united-states'),
		new AraIcon('calculate', 'mat:calculate'),
		new AraIcon('vpnKey', 'mat:vpn_key'),
		new AraIcon('watchLater', 'mat:watch_later'),
		new AraIcon('zoomInMap', 'mat:zoom_in_map'),
		new AraIcon('zoomOutMap', 'mat:zoom_out_map'),

		// Custom/Arasys Icons
		new AraIcon('arrowCollapse', 'ara:arrow_collapse_all', 'mdi:arrow-collapse-all'),
		new AraIcon('arrowExpand', 'ara:arrow_expand_all', 'mdi:arrow-expand-all'),
		new AraIcon('beta', 'ara:beta', 'clarity:beta-solid'),
		new AraIcon('billingUnit', 'ara:invoice_outline', 'mdi:invoice-text-multiple-outline'),
		new AraIcon('billings', 'ara:invoices_outline', 'mdi:invoices-text-multiple-outline'),
		new AraIcon('calculator', 'ara:calculator', 'mdi:calculator-variant-outline'),
		new AraIcon('calendar', 'ara:calendar', 'bx:calendar'),
		new AraIcon('calendar_clock', 'ara:calendar_clock', 'mdi:calendar_clock'),
		new AraIcon('cancelCircleOutline', 'ara:cancel_circle_outline', 'ic:outline-cancel'),
		new AraIcon('checkCircleOutline', 'ara:check_circle_outline', 'ic:outline-check-circle'),
		new AraIcon('checkSmall', 'ara:check_small', 'material-symbols:check-small'),
		new AraIcon('checkboxBlank', 'ara:checkbox_blank_outline', 'mdi:checkbox-blank-outline'),
		new AraIcon('checkboxMarked', 'ara:checkbox_marked_outline', 'mdi:checkbox-marked-outline'),
		new AraIcon('circleFilled', 'ara:circle_filled', 'mdi:circle'),
		new AraIcon('clipboard', 'ara:clipboard', 'mdi:clipboard-text-multiple'),
		new AraIcon('clipboardCheck', 'ara:clipboard_check', 'mdi:clipboard-check-outline'),
		new AraIcon('clipboardOutline', 'ara:clipboard_outline', 'mdi:clipboard-outline'),
		new AraIcon('clipboardPulse', 'ara:clipboard_pulse', 'bi:clipboard-pulse'),
		new AraIcon('clipboardRemove', 'ara:clipboard_remove', 'mdi:clipboard-remove-outline'),
		new AraIcon('coldwater', 'ara:snowflake_melt', 'mdi:snowflake-melt'),
		new AraIcon('consumptionInfo', 'ara:consumption_info'),
		new AraIcon('devices', 'ara:water_meter', 'mdi:electric_meter'),
		new AraIcon('downloadPDF', 'ara:generate_pdf', 'carbon:generate-pdf'),
		new AraIcon('editUser', 'ara:editUser', 'tabler:user-edit'),
		new AraIcon('encrypted_add', 'ara:encrypted_add', 'mdi:encrypted_add'),
		new AraIcon('exportCSV', 'ara:export_csv', 'eos-icons:csv-file'),
		new AraIcon('fileSheet', 'ara:draft', 'mat:draft'),
		new AraIcon('filterOffOutline', 'ara:filter_off_outline', 'mdi:filter-off-outline'),
		new AraIcon('fixAutomated', 'ara:progress_wrench', 'mdi:progress-wrench'),
		new AraIcon('hamburger', 'ara:hamburger', 'mdi:dots-vertical-circle-outline'),
		new AraIcon('house_euro', 'ara:house_euro', 'mdi:payments'),
		new AraIcon('infoOutline', 'ara:info_outline', 'material-symbols:info-outline'),
		new AraIcon('keyAdd', 'ara:key_add', 'mdi:key-add'),
		new AraIcon('mailAsterisk', 'ara:mail_asterisk'),
		new AraIcon('minusCircleOutline', 'ara:minus_circle_outline', 'ic:outline-do-disturb-on'),
		new AraIcon('mobile', 'ara:mobile_3', 'mdi:mobile_3'),
		new AraIcon('networkGraph', 'ara:network_graph', 'ph:graph'),
		new AraIcon('personGroup', 'ara:person_group', 'mdi:person-group'),
		new AraIcon('pin', 'ara:pin', 'mdi:pin'),
		new AraIcon('pinOff', 'ara:pin_off', 'mdi:pin_off'),
		new AraIcon('preview', 'ara:file_find_outline', 'mdi:file-find-outline'),
		new AraIcon('radioWaves', 'ara:radio_waves', 'ix:radio-waves'),
		new AraIcon('radioWavesOff', 'ara:radio_waves_off', 'ix:radio-waves-off'),
		new AraIcon('reactivate', 'ara:account_reactivate_outline', 'mdi:account_reactivate_outline'),
		new AraIcon('reset_wrench', 'ara:reset_wrench', 'mat:reset_wrench'),
		new AraIcon('reviewRun', 'ara:progress_check', 'mdi:progress-check'),
		new AraIcon('sendOutbox', 'ara:file_send_outline', 'mdi:file-send-outline'),
		new AraIcon('smile', 'ara:smile'),
		new AraIcon('smokeDetector', 'ara:smoke_detector', 'material-symbols:detector-smoke-rounded'),
		new AraIcon('tariffBilling', 'ara:tariff_billing', 'mdi:solar-power-variant-outline'),
		new AraIcon('toPrintServiceProvider', 'ara:inbox_arrow_up_outline', 'mdi:inbox-arrow-up-outline'),
		new AraIcon('warmwater', 'ara:temperature_water', 'carbon:temperature-water'),
		new AraIcon('documentScan', 'ara:document_scan', 'material-symbols:document-scanner-outline-rounded'),
	];

	constructor() {
		this.checkForDuplicatedLabels();
	}

	public get(label = '', path = ''): string {
		if (path) {
			return this.allIcons.find((icon) => icon.path === path)?.path;
		}
		return this.allIcons.find((icon) => icon.label === label)?.path;
	}

	public getAllIcons() {
		return this.allIcons;
	}

	findDuplicates() {
		const duplicates = [];
		const labels = this.allIcons.map((obj) => obj.label);
		const counts = {};

		// Count the occurrences of each label
		for (let i = 0; i < labels.length; i++) {
			if (counts[labels[i]]) {
				counts[labels[i]]++;
			} else {
				counts[labels[i]] = 1;
			}
		}

		// Find labels that occur more than once
		for (const label in counts) {
			if (counts[label] > 1) {
				duplicates.push(this.allIcons.filter((obj) => obj.label === label));
			}
		}

		return duplicates;
	}

	checkForDuplicatedLabels() {
		// Check for duplicate Icon labels
		const duplicates = this.findDuplicates();
		let duplicateLabels = '';
		if (duplicates.length > 0) {
			for (const duplicate of duplicates) {
				if (duplicateLabels) {
					duplicateLabels += ', ';
				}
				duplicateLabels += duplicate[0].label;
			}
			throw new Error('Duplicate Icon-Labels found! (' + duplicateLabels + '). Make sure that labels are unique!');
		}
	}
}
